module.exports = __webpack_public_path__ + "img/地址.2a9fba16.png";